module.exports = __webpack_public_path__ + "3ccc3966b95af9cb8e7fb19a4a92d579.png";